import { CodexEntrySchema, CodexEntryType } from "#/index"
import { codexBasicGroups } from "@/constants"
import { cn } from "@/utils"

const codexEntryMap = codexBasicGroups.reduce((acc, group) => {
  acc[group.type] = group
  return acc
}, {} as Record<CodexEntryType, typeof codexBasicGroups[number]>)


interface CodexEntryIconProps {
  entry?: CodexEntrySchema
  type?: CodexEntryType
  className?: string
  style?: React.CSSProperties,
  size?: number
}

const CodexEntryIcon = ({ entry, type, className, style, size = 16 }: CodexEntryIconProps) => {
  if (!entry && !type) {
    return null
  }
  return <span
    className={cn("flex items-center justify-center size-6 bg-fill-2 rounded-md text-quaternary", className)}
    style={style}
  >
    {codexEntryMap[entry?.attributes.type || type || CodexEntryType.Other].icon({ size })}
  </span>
}

export default CodexEntryIcon